import { render, staticRenderFns } from "./WorkerDetails.vue?vue&type=template&id=6e59d23e&scoped=true"
import script from "./WorkerDetails.vue?vue&type=script&lang=js"
export * from "./WorkerDetails.vue?vue&type=script&lang=js"
import style0 from "./WorkerDetails.vue?vue&type=style&index=0&id=6e59d23e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e59d23e",
  null
  
)

export default component.exports